module.exports = __webpack_public_path__ + "static/media/piece-25.fe12134b.png";